var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 899,
    viewBox: "0 0 1440 899",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_240_3741)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_240_3741)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1014.68,
    cy: -108.243,
    rx: 944.396,
    ry: 334.469,
    transform: "rotate(-44.3726 1014.68 -108.243)",
    fill: "url(#paint0_linear_240_3741)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_f_240_3741)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1809.2,
    cy: -642.359,
    rx: 1665.97,
    ry: 596.796,
    transform: "rotate(-44.3726 1809.2 -642.359)",
    fill: "url(#paint1_linear_240_3741)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_240_3741",
    x: 16.0518,
    y: -1094.81,
    width: 1997.26,
    height: 1973.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 142,
    result: "effect1_foregroundBlur_240_3741"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_240_3741",
    x: 402.992,
    y: -2027.39,
    width: 2812.41,
    height: 2770.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 72,
    result: "effect1_foregroundBlur_240_3741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_3741",
    x1: 232.641,
    y1: -231.815,
    x2: 2164.93,
    y2: -49.8044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0991DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0991DB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_240_3741",
    x1: 267.903,
    y1: -579.302,
    x2: 2278.65,
    y2: -604.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D0D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09093A",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_240_3741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 899,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient);
export default __webpack_public_path__ + "static/media/gradient.bbc1cf8f37fae4532b8150f9b845d602.svg";
export { ForwardRef as ReactComponent };